import React from "react";
import { Skeleton } from "antd-mobile";

interface SkeletonTokenListItemProps {
    count: number;
    isFavoriteAble?: boolean;
}

const SkeletonTokenListItem: React.FC<SkeletonTokenListItemProps> = ({
    count,
    isFavoriteAble,
}) => {
    return (
        <div className="flex flex-col">
            {Array.from({ length: count }).map((_, index) => (
                <div
                    key={index}
                    className="flex justify-between h-[72px] items-center mx-[16px]"
                >
                    <div className="flex">
                        {/* 头像 */}
                        <Skeleton className="w-[44px] h-[44px] rounded-full " />
                        {/* 名字 */}
                        <div className="flex flex-col ml-[12px]">
                            <Skeleton className="w-[50px] h-[24px] rounded-[2px] " />
                            <Skeleton className="w-[39px] h-[18px] mt-[4px] rounded-[2px]" />
                        </div>
                    </div>
                    {/* 价格 */}
                    <div className="flex items-center">
                        <div className="flex flex-col items-end">
                            <Skeleton className="w-[50px] h-[24px] rounded-[2px] " />
                            <Skeleton className="w-[39px] h-[18px] mt-[4px] rounded-[2px]" />
                        </div>
                        {isFavoriteAble && (
                            <div className="ml-5">
                                <Skeleton className="w-[20px] h-[20px] rounded-[2px] " />
                            </div>
                        )}
                    </div>
                </div>
            ))}
        </div>
    );
};

export default SkeletonTokenListItem;
